<div class="profile-info-container">
    <div class="info-content">
        <label>Recommended Profile</label>
        <span>{{profileInfo.recommendedProfile}}</span>
    </div>
    <div class="info-content">
        <label>Selected Profile</label>
        <span>{{profileInfo.overriddenProfile ||  profileInfo.recommendedProfile}}</span>
    </div>
</div>